<template>
<v-container fluid>
<v-snackbar
  v-model="snackbar"
  :color="snackbarColor"
  :top="true"
  :right="true"
  :timeout="6000"
  absolute
  >
  {{ message }}
  <v-btn
    dark
    text
    @click="snackbar = false"
  >
    CLOSE
  </v-btn>
</v-snackbar>
  <v-layout mt-5>
    <v-flex xs12>
    <div :class="paginatedItems.length === 7 ? 'invoice_box' : 'invoice_box_empty'">
    <v-card-text>
    <v-tabs fixed-tabs>
     <v-tabs-slider color="#7BC243" style="margin-bottom: 10px;"></v-tabs-slider>
     <v-tab href="#confirm" class="tabs">
       Confirmed Invoices
     </v-tab>
     <v-tab href="#generate" class="tabs" v-if="canConfirmInvoice">
      Generate Invoices
     </v-tab>
     <v-tab-item value="confirm" :key="1">
          <table class="table" height="350">
            <thead class="thead">
              <tr>
                <th scope="col">Marketer</th>
                <th scope="col">Buyer</th>
                <th scope="col">No of Invoices</th>
                <th scope="col">Value(USD)</th>
                <th scope="col">Date</th>
                <th scope="col"></th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="item in paginatedItems" v-bind:key="item.id">
                <td>{{ item.marketerName != null ? item.marketerName : '' }}</td>
                <td>{{ item.buyerName != null ? item.buyerName : '' }}</td>
                 <td>{{ item.auctionResultsSize }}</td>
                <td>{{ item.invoiceAmount }}</td>
                <td>{{ item.dateCreated | prettyDate }}</td>
                <td class="actions">
                  <v-menu offset-y>
                    <template v-slot:activator="{ on }">
                     <v-btn
                      color="primary"
                      v-on="on"
                      flat
                      icon

                    >
                      <v-icon small> more_horiz </v-icon>
                    </v-btn>
                    </template>
                    <v-list>
                      <v-list-item @click="viewInvoiceDetails(item)">
                        <v-list-item-title> View </v-list-item-title>
                      </v-list-item>
                      <v-list-item @click="triggerDownload(item)">
                        <v-list-item-title> Download </v-list-item-title>
                      </v-list-item>
                    </v-list>
                  </v-menu>
                </td>
              </tr>
            </tbody>
          </table>
          <v-card-actions>
            <span class="paginationtext"> Showing {{ page }} of {{ numberOfLinks }} pages </span>
            <v-spacer></v-spacer>
            <v-pagination
            v-model="page"
            :length="numberOfLinks"
            :total-visible="7"
            color="secondary"
                class="accent--text logoutbtn"
          ></v-pagination>
          </v-card-actions>
     </v-tab-item>
     <v-tab-item value="generate" :key="2">
      <table class="table">
            <thead class="thead">
              <tr>
                <th scope="col">Lot Number</th>
                <th scope="col">Buyer</th>
                <th scope="col">Price(USD)</th>
                <th scope="col">Weight</th>
                <th scope="col">Marks</th>
                <th scope="col">Date</th>
                <th scope="col"></th>
              </tr>
            </thead>
            <tbody>
              <p v-if="loadingUnconfirmed" class="loader"> Getting data... </p>
              <tr v-for="item in genpaginatedItems" v-bind:key="item.id">
                <td>{{ item.lotNumber}}</td>
                <td>{{ item.buyer != null ? item.buyer.organisationName : '' }}</td>
                <td>{{ item.invoiceAmount}}</td>
                <td>{{ item.totalWeight}}</td>
                <td>{{ item.catalogue != null ? item.catalogue.marks : '' }}</td>
                <td>{{ item.created | prettyDate }}</td>
                <td class="actions">
                  <v-menu offset-y>
                    <template v-slot:activator="{ on }">
                     <v-btn
                      color="primary"
                      v-on="on"
                      flat
                      icon

                    >
                      <v-icon small> more_horiz </v-icon>
                    </v-btn>
                    </template>
                    <v-list>
                      <v-list-item @click="approveInvoice(item)">
                        <v-list-item-title> Approve </v-list-item-title>
                      </v-list-item>
                    </v-list>
                  </v-menu>
                </td>
              </tr>
            </tbody>
          </table>
          <v-card-actions>
            <span class="paginationtext"> Showing {{ generatedInvoicesPage }} of {{ genNumberOfLinks }} pages </span>
            <v-spacer></v-spacer>
            <v-pagination
            v-model="generatedInvoicesPage"
            :length="genNumberOfLinks"
            :total-visible="7"
            color="secondary"
                class="accent--text logoutbtn"
          ></v-pagination>
          </v-card-actions>
     </v-tab-item>
    </v-tabs>
    </v-card-text>
    </div>
  </v-flex>
  <v-dialog v-model="invoiceDialog" max-width="900">
      <v-card>
        <v-card-title class="title accent--text text-capitalize">
          Invoice Details
        </v-card-title>
        <v-card-text>
          <v-data-table :headers="invoiceHeaders" :items="itemInvoices" class="mytable" hide-actions>
            <template slot="headerCell" slot-scope="{ header }">
              <span
                class="body-2 font-weight-regular accent--text"
                v-text="header.text"
              />
            </template>
            <template v-slot:items="props">
              <td>{{ props.item.id }}</td>
              <td>{{ props.item.lotNumber }}</td>
               <td>{{ props.item.catalogue.outTurn}}</td>
               <td>{{ props.item.auctionResult.grade}}</td>
               <td>{{ props.item.totalNumberOfBags}}</td>
               <td>{{ props.item.totalWeight }}</td>
               <td>{{ props.item.invoiceAmount }}</td>
               <td>{{ props.item.totalValue}}</td>
              <td>{{ props.item.auctionResult.dateBought | prettyDate }}</td>
            </template>
          </v-data-table>
        </v-card-text>
        <v-card-actions>
          <v-spacer> </v-spacer>
          <v-btn color="primary" round @click="invoiceDialog = false"> Close </v-btn>
        </v-card-actions>
      </v-card>
     </v-dialog>
  </v-layout>
</v-container>
</template>
<script>
import axios from 'axios'
import config from '../../../config'
import store from '../../../store'

export default {
	name: 'viewinvoice',
	data: function () {
		return {
			headers: [
				{ text: 'Buyer Code', value: 'buyerCode' },
				{ text: 'Buyer Name', value: 'organisationName' },
				{ text: 'Invoice Amount', value: 'invoiceAmount' },
				{ text: 'No Of Bags', value: 'totalNumberOfBags' },
				{ text: 'Weight', value: 'totalWeight' },
				{ text: 'Invoice Date', value: 'created' }
			],
			invoiceHeaders: [
				{ text: 'Id', value: 'id' },
				{ text: 'lot Number', value: 'lotNumber' },
				{ text: 'OutTurn', value: 'OutTurn' },
				{ text: 'Grade', value: 'Grade' },
				{ text: 'Bags', value: 'Bags' },
				{ text: 'Weight', value: 'totalWeight' },
				{ text: 'Price Per Bag', value: 'price' },
				{ text: 'Value(USD)', value: 'invoiceAmount' },
				{ text: 'Invoice Date', value: 'created' }
			],
			data: [],
			itemInvoices: [],
			message: '',
			loading: false,
			pagination: {},
			snackbar: false,
			snackbarColor: '',
			dialog: false,
			paginatedItems: [],
			numberOfLinks: 0,
			numberOfItemsPerPage: window.innerHeight <= 600 ? 6 : window.innerHeight > 600 && window.innerHeight <= 1000 ? 14 : 20,
			page: 1,
			currentPage: 0,
			invoiceDialog: false,
			generatedInvoices: [],
			genpaginatedItems: [],
			genNumberOfLinks: 0,
			generatedInvoicesPage: 1,
			permissions: [],
			loadingUnconfirmed: false
		}
	},
	mounted () {
		this.getApprovedInvoices(this.currentPage)
		this.getGeneratedInvoices()
		this.permissions = store.state.user.roleId.permissions
	},
	computed: {
		canConfirmInvoice: function () {
			return this.hasPerm('CAN_CONFIRM_INVOICE')
		}
	},
	watch: {

		// files () {
		// 	this.paginatedFiles = this.files
		// 	//   this.paginationMethod(this.files, 1, this.numberOfItemsPerPage)
		// 	// this.numberOfLinks = Math.ceil(this.files.length / this.numberOfItemsPerPage)
		// },
		// page: function (val) {
		// 	this.paginatedFiles = this.getSeasons(val - 1)
		// 	// this.paginationMethod(this.files, val, this.numberOfItemsPerPage)
		// },
		invoices: function () {
			// this.paginatedItems=this.invoices
			this.paginatedItems = this.data()
			//   this.paginationMethod(this.invoices, 1, this.numberOfItemsPerPage)
			// this.numberOfLinks = Math.ceil(this.invoices.length / this.numberOfItemsPerPage)
		},
		page: function (val) {
			this.paginatedItems = this.getApprovedInvoices(val - 1)
			// this.paginationMethod(this.invoices, val, this.numberOfItemsPerPage)
		},
		generatedInvoices: function () {
			this.genpaginatedItems = this.paginationMethod(this.generatedInvoices, 1, this.numberOfItemsPerPage)
			this.genNumberOfLinks = Math.ceil(this.generatedInvoices.length / this.numberOfItemsPerPage)
		},
		generatedInvoicesPage: function (val) {
			this.genpaginatedItems = this.paginationMethod(this.generatedInvoices, val, this.numberOfItemsPerPage)
		}
	},
	methods: {
		hasPerm (permission) {
			return this.permissions.includes(permission)
		},
		getGeneratedInvoices () {
			this.loadingUnconfirmed = true
			const url = config.serverURI + '/invoice/unapproved'
			this.loading = true
			axios.get(url)
				.then(response => {
					console.log('Approved invoices', response.data)
					this.loading = false
					this.generatedInvoices = response.data
					this.loadingUnconfirmed = false
				})
				.catch(error => {
					// Request failed.
					console.log('error', error.response)
					this.message = error.response.status
					this.snackbar = true
					this.snackbarColor = 'error'
					this.loadingUnconfirmed = false
				})
			return this.generatedInvoices
		},
		viewInvoiceDetails (item) {
			// this.invoiceDialog = true
			// this.itemInvoices = item.invoices
			const url = config.serverURI + '/invoice/getAuctionsByInvoice'
			axios.post(url, item)
				.then(response => {
					// const { items, totalPages, totalItems } = response.data
					this.itemInvoices = response.data
					this.itemInvoices.forEach(invoice => {
						if (invoice.created) {
							const date = new Date(invoice.created)
							const formattedDate = `${date.getFullYear()}-${(date.getMonth() + 1).toString().padStart(2, '0')}-${date.getDate().toString().padStart(2, '0')} ${date.getHours().toString().padStart(2, '0')}:${date.getMinutes().toString().padStart(2, '0')}:${date.getSeconds().toString().padStart(2, '0')}`
							// const date = new Date(invoice.created)
							invoice.created = formattedDate // You can update the 'created' property in the invoice object with the formatted date.
						}
					})
					this.itemInvoices = response.data
					this.invoiceDialog = true
				})
				.catch(error => {
					// Request failed.
					console.log('error', error.response)
					this.message = error.response.status
					this.snackbar = true
					this.snackbarColor = 'error'
				})
			return this.itemInvoices
		},
		paginationMethod (items, pageNumber, limitPerPage) {
			pageNumber = pageNumber - 1
			const from = pageNumber * limitPerPage
			let to = (pageNumber + 1) * limitPerPage
			if (to >= items.length) {
				to = items.length
			}
			return items.slice(from, to)
		},
		getApprovedInvoices (val) {
			const url = config.serverURI + '/invoice/approved?page=' + val + '&size' + this.numberOfItemsPerPage
			axios.get(url)
				.then(response => {
					this.invoices = response.data.content
					this.numberOfLinks = response.data.page.totalPages
					this.numberOfItemsPerPage = response.data.page.size
					this.currentPage = response.data.page.number
				})
				.catch(error => {
					// Request failed.
					console.log('error', error.response)
					this.message = error.response.status
					this.snackbar = true
					this.snackbarColor = 'error'
				})
			return this.data
		},
		showInvoices (item) {
			this.dialog = true
			this.itemInvoices = item.data
		},
		triggerDownload (item) {
			console.log(item.data)
			const url = config.serverURI + '/invoice/download'
			axios({ url: url, method: 'POST', responseType: 'blob', data: item })
				.then(response => {
					const url = window.URL.createObjectURL(new Blob([response.data], { type: 'application/pdf' }))
					const link = document.createElement('a')
					link.href = url
					const itemFileName = item.buyerName + '_' + item.dateCreated + '.pdf'
					link.setAttribute('download', itemFileName)
					document.body.appendChild(link)
					link.click()
				})
				.catch(error => {
					// Request failed.
					console.log('error', error.response)
					this.message = 'Error occurred'
					this.snackbar = true
					this.snackbarColor = 'error'
				})
		},
		approveInvoice (item) {
			const url = config.serverURI + '/invoice/confirm'
			var selected = []
			selected.push(item)
			axios.post(url, selected)
				.then(response => {
					console.log('Invoices', response.data)
					this.snackbar = true
					if (response.data.error !== false) {
						this.message = response.data.message
						this.snackbarColor = 'error'
						return
					}
					this.getGeneratedInvoices()
					this.message = response.data.message
					this.snackbarColor = 'primary'
				})
				.catch(error => {
					var data = error.response.data
					this.message = data.message
					this.snackbarColor = 'error'
					this.snackbar = true
				})
		}
	}
}

</script>
<style>
.mytable .v-table tbody tr:not(:last-child) {
    border-bottom: none;
}
.invoice_box_empty {
  position: relative;
  background: #fff;
  border: 1px solid #707070;
}

.invoice_box {
  position: relative;
  background: #fff;
  border: 1px solid #707070;
}
.invoice_box:after, .invoice_box:before {
  right: 100%;
  top: 39%;
  border: solid transparent;
  content: " ";
  height: 0;
  width: 0;
  position: absolute;
  pointer-events: none;
}

.invoice_box:after {
  border-color: rgba(255, 255, 255, 0);
  border-right-color: #fff;
  border-width: 20px;
  margin-top: -20px;
}
.invoice_box:before {
  border-color: rgba(112, 112, 112, 0);
  border-right-color: #707070;
  border-width: 21px;
  margin-top: -21px;
}
.tabs {
   font-weight: 600;
   font-color: #4E4E4E;
}

.loader {
  font-weight: 600;
  font-color: #4E4E4E;
  margin: 10px;
  font-size: 20px;
}
</style>
